import Wasm from "~/wasm/wasm";
import { IWasmStoreMarker, TMarkerVisualType } from "../store/interfaces";
import WasmMapMarker from "./wasm-map-marker";

export default class WasmMapMarkerSharedPosition {
	_arrowMarker: WasmMapMarker;

	_iconMarker: WasmMapMarker;

	constructor(wasm: Wasm, data: IWasmStoreMarker) {
		this._arrowMarker = new WasmMapMarker(wasm, {
			...data,
			// furt standard
			visual: "standard",
		}, {
			customTexture: "position-share-image-arrow",
		});
		// nechceme uhel, jiny typ
		this._iconMarker = new WasmMapMarker(wasm, {
			...data,
			angle: 0,
			type: "position-share-image",
		});
	}

	destroy() {
		this._arrowMarker.destroy();
		this._iconMarker.destroy();
	}

	setPosition(wgsLon: number, wgsLat: number) {
		this._arrowMarker.setPosition(wgsLon, wgsLat);
		this._iconMarker.setPosition(wgsLon, wgsLat);
	}

	setVisual(visual: TMarkerVisualType) {
		this._arrowMarker.setVisual(visual);
		this._iconMarker.setVisual(visual);
	}

	/* eslint-disable-next-line */
	async setIcon(url: string) {
	}

	get wasmIds() {
		return [
			...this._arrowMarker.wasmIds,
			...this._iconMarker.wasmIds,
		];
	}

	setVisibility(visible: boolean) {
		this._arrowMarker.setVisibility(visible);
		this._iconMarker.setVisibility(visible);
	}

	setAngle(angle: number) {
		this._arrowMarker.setAngle(angle);
		// pro ikonu nechceme
	}

	setBringToTheFront(bringToTheFront: boolean) {
		this._arrowMarker.setBringToTheFront(bringToTheFront);
		this._iconMarker.setBringToTheFront(bringToTheFront);
	}
}
